<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [(update)]="updateFlag"
  [callbackFunction]="cbChart"
></highcharts-chart>
